export const UNAVAILABLE_DATA_DISPLAY = '-';
